/* global Drupal, jQuery, window, document, SmoothScroll, history, location */
/* eslint-disable func-names, no-new, object-shorthand, no-restricted-globals */
(($) => {
  Drupal.behaviors.jeromeTheme = {
    attach: (context, settings) => {
      window.once('jerome.theme', document.body).forEach(() => {
        // Search toggle
        $('#block-searchform').each(function () {
          const self = $(this);
          $('h2', this).click(() => {
            $('form', self).slideToggle('fast');
            $('#block-searchform input#edit-keys').focus();
          });
        });

        // jQuery toggle text
        $.fn.extend({
          toggleText: function (a, b) {
            return this.text(this.text() === b ? a : b);
          },
        });

        // Smooth scroll anchor links, except for carousel control
        new SmoothScroll('a[href*="#next-panel"]', {
          offset: () => {
            let offset = -15;
            if ($('body').hasClass('adminimal-admin-toolbar')) offset += 39;
            if ($('body').hasClass('toolbar-tray-open')) offset += 40;
            if ($('body').hasClass('toolbar-vertical')) offset -= 40;
            return offset;
          },
        });

        // Move modals to the bottom of the bottom to escape the wrapper and its
        // z-index issues
        $('.modal').each((index, element) => $(element).appendTo('body'));

        // When a bootstrap modal is closed, stop youtube videos
        $(document).on('hide.bs.modal', () => {
          // Stop playing youtube videos in modals.
          $('.video-embed-field-provider-youtube iframe').each(function () {
            this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
          });
        });

        // Tab behavior
        if (window.location.hash) {
          const hashVal = window.location.hash.replace('#', '');
          const $activeTab = $(`a[data-toggle="tab"][data-slug="${hashVal}"]`);
          $activeTab.tab('show');
        }
        $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
          const slug = $(e.target).data('slug');
          if (history.pushState) {
            history.pushState(null, null, `#${slug}`);
          } else {
            location.hash = `#${slug}`;
          }
        });

        // Mobile close button
        $('.mm-navbar').each((index, navbar) => {
          const $closeButton = $('<button class="mm-close-mm">Close</button>');
          $closeButton.on('click touch', () => {
            // $('#off-canvas').data('mmenu').close();
            window.mmenuApi.close(document.getElementById('off-canvas'));
          });
          if (!$(navbar).find('.mm-close-mm').length) {
            $(navbar).append($closeButton);
          }
        });

        // Hover listeners
        var menuItems = document.querySelectorAll('.navbar-nav .dropdown.expanded');
        for (var i = 0; i < menuItems.length; i++) {
          var menuItem = menuItems[i];
          var hoverListener = hoverintent(menuItem,
            function() {
              var $menu = $(this);
              var $submenu = $menu.find('.sub-menu');
              $submenu.removeClass('slideInDown').addClass('slideInDown');
              $menu.addClass('open');
            },
            function() {
              var $menu = $(this);
              var $submenu = $menu.find('.sub-menu');
              $submenu.removeClass('slideInDown').addClass('slideOutUp');
              setTimeout(function() {
                $menu.removeClass('open');
                $submenu.addClass('slideInDown').removeClass('slideOutUp');
              }, 400);
            }
          );
        }

        $('.paragraph--type-eligibility.collapsible-Off .field--name-field-section, .paragraph--type-faq-group.collapsible-Off .field--name-field-faq-item').each(function() {
          var self = $(this);
          $('.panel-collapse', self).collapse('show');
        });

        $('.paragraph--type-eligibility:not(.collapsible-Off) .field--name-field-section, .paragraph--type-faq-group:not(.collapsible-Off) .field--name-field-faq-item').each(function() {
          var self = $(this);
          $(this).prepend('<span class="faq-toggle expandall">Expand all +</span>');

          $('.faq-toggle', self).click(function() {
            if ($(this).hasClass('expandall')) {
              $('.panel-collapse', self).collapse('show');
              $(this).text('Collapse all -').removeClass('expandall').addClass('collapseall');
              //$(this).toggleText('Expand all', 'Collapse all');
            }
            else {
              $('.panel-collapse', self).collapse('hide');
              $(this).text('Expand all +').removeClass('collapseall').addClass('expandall');
              //$(this).toggleText('Expand all', 'Collapse all');
            }
          });
        });
      });
    },
  };
})(jQuery);








// });
